import { useState } from "react";
import { Alert, Button, Form, Spinner } from "react-bootstrap";

// Create/edit for one table's description. The table itself is fixed once described — pick from the
// tables that don't have one yet on create; editing only ever changes the description text.
export default function TableDescriptionModal({ mode, initial, availableTables, saving, error, onSubmit, onClose }) {
  const isEdit = mode === "edit";
  const [tableName, setTableName] = useState(initial?.tableName || availableTables[0] || "");
  const [description, setDescription] = useState(initial?.description || "");

  function submit(e) {
    e.preventDefault();
    onSubmit({ tableName, description: description.trim() });
  }

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="form-modal" onClick={(e) => e.stopPropagation()}>
        <div className="form-modal-head">
          <div className="form-modal-title">
            {isEdit ? `Edit description for "${initial.tableName}"` : "Describe a table"}
          </div>
          <button className="icon-btn" onClick={onClose} title="Close">
            ✕
          </button>
        </div>
        <Form onSubmit={submit}>
          <div className="form-modal-body">
            {error && <Alert variant="danger">{error}</Alert>}
            <Form.Group className="mb-3">
              <Form.Label>Table</Form.Label>
              {isEdit ? (
                <Form.Control value={tableName} disabled />
              ) : (
                <Form.Select value={tableName} onChange={(e) => setTableName(e.target.value)} required>
                  {availableTables.length === 0 && <option value="">— every table already has a description —</option>}
                  {availableTables.map((t) => (
                    <option key={t} value={t}>
                      {t}
                    </option>
                  ))}
                </Form.Select>
              )}
              {isEdit && <Form.Text className="text-muted">The table can't be changed after creation — delete and re-add to describe a different one.</Form.Text>}
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
                placeholder='What this table represents — e.g. "One row per booking transaction. The fact table everything else joins onto."'
              />
              <Form.Text className="text-muted">
                Shown to the agent through list_fields, so write it as you would explain the table to a
                new analyst — what one row means, what it's for, anything easy to get wrong.
              </Form.Text>
            </Form.Group>
          </div>
          <div className="form-modal-foot">
            <Button variant="outline-secondary" type="button" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="primary" type="submit" disabled={saving || (!isEdit && !tableName)}>
              {saving ? <Spinner animation="border" size="sm" /> : isEdit ? "Save changes" : "Create"}
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
}
